import compact from 'lodash-es/compact'
import { PlatformData } from '@/components/kol/navigation/platform-select'
import { Optional } from '@/types/optional'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import { convertPlatformType } from '@/utils/convert-platform'
import { sortByPlatformTypeScore } from '@/utils/get-main-platforms'

const getKolPlatformDatum = (kolInfo: KolSchemaModel): PlatformData[] => {
  return compact(
    sortByPlatformTypeScore(kolInfo.links, 'platformType').map(
      (link): Optional<PlatformData> => {
        const platform = convertPlatformType(link.platformType)

        if (!platform) {
          return undefined
        }

        const follower = kolInfo?.kpi.find(
          (kpi) => kpi.platform === link.type,
        )?.follower

        return {
          ...platform,
          follower,
          url: link.url,
        }
      },
    ),
  )
}

export default getKolPlatformDatum
